import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { CONTACT } from "@/lib/data";

export default function ContactInfoPanel() {
  return (
    <div className="col-span-12 md:col-span-5 space-y-4">
      <div data-testid="contact-info-address" className="p-6 bg-[#f5f5f5] border-l-4 border-[#1FA8E0]">
        <MapPin size={22} className="text-[#0d4c7d] mb-3" />
        <div className="overline mb-1">Morada</div>
        <div className="font-display font-bold text-lg text-[#222] uppercase tracking-wide leading-snug">
          {CONTACT.moradaLinhas.map((linha, i) => (
            <div key={i}>{linha}</div>
          ))}
        </div>
      </div>
      <div data-testid="contact-info-phone" className="p-6 bg-[#f5f5f5] border-l-4 border-[#1FA8E0]">
        <Phone size={22} className="text-[#0d4c7d] mb-3" />
        <div className="overline mb-1">Telefone</div>
        <a href={CONTACT.telefoneHref} className="font-display font-bold text-xl text-[#222] uppercase tracking-wide hover:text-[#0d4c7d]">
          {CONTACT.telefone}
        </a>
      </div>
      <div data-testid="contact-info-email" className="p-6 bg-[#f5f5f5] border-l-4 border-[#1FA8E0]">
        <Mail size={22} className="text-[#0d4c7d] mb-3" />
        <div className="overline mb-1">Email</div>
        <a href={CONTACT.emailHref} className="font-display font-bold text-xl text-[#222] uppercase tracking-wide hover:text-[#0d4c7d] break-all">
          {CONTACT.email}
        </a>
      </div>
      <div className="p-6 bg-[#0d4c7d] text-white">
        <Clock size={22} className="text-[#1FA8E0] mb-3" />
        <div className="overline mb-1 text-[#1FA8E0]">Horário</div>
        <div className="font-display font-bold text-lg uppercase tracking-wide leading-snug">
          Seg–Sex<br />
          <span className="text-base">09h00 — 12h30</span><br />
          <span className="text-base">14h00 — 18h00</span>
        </div>
      </div>
    </div>
  );
}
